import React, { useState } from 'react'
import ImgBox from './imgBox';
import { RiEyeCloseFill } from "react-icons/ri";
import { FaEye } from "react-icons/fa";
import { Tooltip } from 'react-tooltip';
const Gallery = ({ items, title }) => {
  const [showGallery, setShowGallery] = useState(true)
  const handleImageClick = () => {
  }
  return (
    <>
      {items?.length > 0 && <div className="flex gap-x-4 flex-wrap gap-y-2 w-full  justify-center">
        <div className="w-full gap-4 flex">
          <h2 className="text-2xl font-semibold font-merriweather mb-3">{title}</h2><div className='mt-3 cursor-pointer'> {showGallery ? <> <Tooltip
            id={`hide`}
            place={"top"}
          />
            <div
              // eslint-disable-next-line
              data-tooltip-id={`hide`}
              data-tooltip-content={`Zum Ausblenden der Vorschau anklicken`}
            >
              <FaEye onClick={(() => setShowGallery(!showGallery))} />
            </div></> :
            <> <Tooltip
              id={`view`}
              place={"top"}
            />
              <div
                // eslint-disable-next-line
                data-tooltip-id={`view`}
                data-tooltip-content={`Zum Anzeigen des Bildes anklicken`}
              >
                <RiEyeCloseFill onClick={(() => setShowGallery(!showGallery))} />
              </div></>
          }</div>
        </div>
        {showGallery && <>{items.map((item, index) => (
          <div
            key={item?.id || index}
            className="w-full sm:w-1/3 md:w-1/4 lg:w-1/5 mb-5 relative group rounded-lg"
            onClick={() => handleImageClick(item)}>
            <ImgBox imageUrl={item?.url} />
          </div>
        ))}</>}
      </div>}
    </>)
}

export default Gallery